module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/icons/article-9049a683b9c570ed999185e962de824d.svg&quot;;"